const findMeta = (attribute, key) => document.head.querySelector(`meta[${attribute}="${key}"]`);

export function setMeta(attribute, key, content) {
  let element = findMeta(attribute, key);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export function setCanonical(url) {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", url);
}

export function removeCanonical() {
  document.head.querySelector('link[rel="canonical"]')?.remove();
}

export function setStructuredData(data) {
  const id = "gi-structured-data";
  let element = document.getElementById(id);
  if (!element) {
    element = document.createElement("script");
    element.id = id;
    element.type = "application/ld+json";
    document.head.appendChild(element);
  }
  element.textContent = JSON.stringify(data);
}

export function removeStructuredData() {
  document.getElementById("gi-structured-data")?.remove();
}

export function setSocialMetadata({ title, description, canonical, image, imageAlt, type = "website", locale }) {
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:type", type);
  setMeta("property", "og:url", canonical);
  setMeta("property", "og:site_name", "Gi Inovações");
  setMeta("property", "og:locale", locale === "es" ? "es_ES" : "pt_BR");
  setMeta("property", "og:image", image);
  setMeta("property", "og:image:alt", imageAlt);
  setMeta("name", "twitter:card", "summary_large_image");
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", image);
  setMeta("name", "twitter:image:alt", imageAlt);
}